// social
export {default as LinkedIn} from "./linkedIn/index";
export {default as GitHub} from "./gitHub/index";
export {default as GitLab} from "./gitLab/index";
export {default as Telegram} from "./telegram/index";
export {default as Gmail} from "./gmail/index";
export {default as JsIcon} from "./jsIcon/index";
export {default as TsIcon} from "./tsIcon/index";
export {default as ReactIcon} from "./reactIcon/index";
export {default as CssIcon} from "./cssIcon/index";

// animation icon
export {default as DoubleWave} from "./animationIcons/doubleWave";
export {default as Wave} from "./animationIcons/wave";
export {default as Triangle} from "./animationIcons/tringle";
export {default as Line} from "./animationIcons/line";
export {default as SemiCircle} from "./animationIcons/semiCircle";

//other
export {default as Logo} from "./logo/index";
export {default as AnimatedLogo} from "./animatedLogo/index";
export {default as ArrowIcon} from "./arrowIcon/index";
export {default as Okay} from "./okay/index";
export {default as Download} from "./download/index";
